import { clamp, MAX_DIAGONAL_VISIBLE_HEIGHT, MAX_DIAGONAL_LABEL_WIDTH, LINE_HEIGHT } from '@shopify/polaris-viz-core';
import { getWidestLabel } from './getWidestLabel.js';
import { truncateLabels } from './truncateLabels.js';

function getDiagonalLabels({
  characterWidths,
  labels,
  longestLabelWidth,
  targetHeight,
  targetWidth
}) {
  const clampedTargetWidth = clamp({
    amount: longestLabelWidth,
    min: targetWidth,
    max: MAX_DIAGONAL_LABEL_WIDTH
  });
  const truncatedLabels = truncateLabels({
    labels,
    targetWidth: clampedTargetWidth,
    targetHeight,
    characterWidths,
    skipEndWordTruncate: true
  });
  const lines = [];
  const centerPoint = targetWidth / 2 - LINE_HEIGHT / 2;

  for (let i = 0; i < labels.length; i++) {
    lines[i] = [];
    lines[i].push({
      truncatedText: truncatedLabels[i].truncatedName,
      fullText: truncatedLabels[i].text,
      y: centerPoint,
      x: centerPoint,
      dominantBaseline: 'hanging',
      width: clampedTargetWidth,
      height: LINE_HEIGHT,
      textAnchor: 'end',
      transform: `rotate(-45)`
    });
  }

  const {
    truncatedWidth
  } = getWidestLabel(truncatedLabels);
  return {
    lines,
    containerHeight: clamp({
      amount: getRotatedHeight(truncatedWidth, 45, targetHeight),
      min: 0,
      max: MAX_DIAGONAL_VISIBLE_HEIGHT
    })
  };
}

function getRotatedHeight(width, angle, originalHeight) {
  const radians = Math.PI / 180 * angle;
  const hypotenuse = width * Math.sin(radians);
  const opp = originalHeight * Math.cos(radians);
  return Math.round(hypotenuse + opp);
}

export { getDiagonalLabels };
